import { render } from "./PartnerRegistrationEdit.vue?vue&type=template&id=2fd43555&scoped=true"
import script from "./PartnerRegistrationEdit.vue?vue&type=script&lang=js"
export * from "./PartnerRegistrationEdit.vue?vue&type=script&lang=js"

import "./PartnerRegistrationEdit.vue?vue&type=style&index=0&id=2fd43555&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fd43555"]])

export default __exports__